export default __webpack_public_path__ + "static/media/akar-icons_search.0129c00d.svg";